module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac4d8ac0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue2-google-maps/dist/components/map.vue
// module id = 763
// module chunks = 1